const shapePages = [
  { title: 'Shape overview', slug: 'commands-shape' },
  { title: 'The Strategy', slug: 'the-strategy' },
  { title: 'Brief', slug: 'brief' },
  { title: 'Product Strategy', slug: 'product-strategy' },
  { title: 'Strategy view', slug: 'strategy-view' },
  { title: 'Strategy output', slug: 'strategy-output' },
  { title: 'Competitor Analysis', slug: 'competitor-analysis' },
  { title: 'Design Vision', slug: 'design-vision' },
];

const decidePages = [
  { title: 'Decide overview', slug: 'commands-decide' },
  { title: 'Decisions', slug: 'decisions' },
  { title: 'Design Authority', slug: 'design-authority' },
  { title: 'Authority & approval', slug: 'trust-model' },
];

const buildPages = [
  { title: 'Build overview', slug: 'commands-build' },
  { title: 'Action Plan', slug: 'action-plan' },
  { title: 'Calendar', slug: 'calendar-view' },
  { title: 'Documents', slug: 'exports' },
  { title: 'README Generator', slug: 'readme-generator' },
  { title: 'Statement of Work', slug: 'statement-of-work' },
  { title: 'Shared plan views', slug: 'sharing' },
  { title: 'Start design work', slug: 'design-authority-start' },
  { title: 'Build the knowledge base', slug: 'design-authority-knowledge' },
];

const checkPages = [
  { title: 'Check overview', slug: 'commands-check' },
  { title: 'Improve an experience', slug: 'design-authority-improve' },
  { title: 'Check work before delivery', slug: 'design-authority-check' },
  { title: 'Design Authority tools', slug: 'design-authority-reference' },
];

const maintainPages = [
  { title: 'Learn & Maintain overview', slug: 'commands-maintain' },
  { title: 'Pulse', slug: 'pulse' },
  { title: 'Jobs & Routines', slug: 'jobs-and-routines' },
  { title: 'How Pabs learns', slug: 'learnings-engine-concept' },
  { title: 'How learnings work', slug: 'learnings-how-it-works' },
  { title: 'Capture learnings', slug: 'learnings-capturing' },
  { title: 'Review learnings', slug: 'learnings-reviewing' },
  { title: 'Maintain design quality', slug: 'design-authority-maintain' },
];

export const docsNav = [
  {
    title: 'Start Here',
    slug: 'getting-started',
    alwaysOpen: true,
    pages: [
      { title: 'Quick Start', slug: 'create-your-first-plan' },
      { title: 'Install and initialize Pabs', slug: 'install-pabs' },
      { title: 'What is Pabs?', slug: 'what-is-pabs' },
    ],
  },
  {
    title: 'Decisions & Authority',
    slug: 'authority-workflows',
    alwaysOpen: true,
    pages: [
      { title: 'Understand the opportunity and define intent', slug: 'workflow-shape' },
      { title: 'Make decisions before execution', slug: 'workflow-decide' },
      { title: 'Give people and agents direction', slug: 'workflow-build' },
      { title: 'Review work before it advances', slug: 'workflow-check' },
      { title: 'Keep the product aligned', slug: 'workflow-maintain' },
    ],
  },
  {
    title: 'Commands & Features',
    slug: 'commands-features',
    pages: [{ title: 'All commands', slug: 'command-reference' }],
    groups: [
      { title: 'Shape', slug: 'shape', pages: shapePages },
      { title: 'Decide', slug: 'decide', pages: decidePages },
      { title: 'Build', slug: 'build', pages: buildPages },
      { title: 'Check', slug: 'check', pages: checkPages },
      { title: 'Learn & Maintain', slug: 'learn-maintain', pages: maintainPages },
    ],
  },
  {
    title: 'Connectors & MCP',
    slug: 'connectors-mcp',
    pages: [
      { title: 'Connect an AI client', slug: 'integrations-overview' },
      { title: 'Get your MCP URL', slug: 'integrations-setup' },
      { title: 'Claude Code & Desktop', slug: 'integrate-claude' },
      { title: 'Cursor', slug: 'integrate-cursor' },
      { title: 'Replit', slug: 'integrate-replit' },
      { title: 'Lovable', slug: 'integrate-lovable' },
      { title: 'Figma Make', slug: 'integrate-figma-make' },
      { title: 'Figma', slug: 'integrate-figma' },
      { title: 'Google Stitch', slug: 'integrate-google-stitch' },
      { title: 'Bolt, v0 & document handoffs', slug: 'integrate-vibe-coding' },
      { title: 'More tools', slug: 'integrate-other' },
      { title: 'Data connectors', slug: 'connectors' },
      { title: 'ask_pabs_agent reference', slug: 'ask-pabs-agent' },
      { title: 'Connect Design Authority', slug: 'design-authority-connect' },
    ],
  },
  {
    title: 'Trust, Privacy & Billing',
    slug: 'trust-account',
    pages: [
      { title: 'Data, privacy & security', slug: 'data-privacy-security' },
      { title: 'Plans & usage', slug: 'billing' },
    ],
  },
  {
    title: 'Troubleshooting',
    slug: 'help',
    pages: [{ title: 'Troubleshooting', slug: 'troubleshooting' }],
  },
  {
    title: 'Changelog & Roadmap',
    slug: 'updates',
    pages: [
      { title: 'Changelog', slug: 'changelog' },
      { title: 'Roadmap', slug: 'roadmap' },
    ],
  },
];

const visiblePages = docsNav.flatMap((section) => [
  ...(section.pages || []).map((page) => ({ ...page, section: section.title })),
  ...(section.groups || []).flatMap((group) =>
    group.pages.map((page) => ({ ...page, section: section.title, group: group.title }))
  ),
]);

export const allDocPages = visiblePages;

export const defaultDocSlug = 'create-your-first-plan';
